import { TARGET_LINK } from '@savgroup-front-common/constants';
import Bold from '@savgroup-front-common/core/atoms/Bold/Bold';
import { Link } from '@savgroup-front-common/core/atoms/link';
import { QualireparLogo } from '@savgroup-front-common/core/atoms/Logo/QualireparLogo/QualireparLogo';
import { $BonusLine } from '@savgroup-front-common/core/components/Quotation';
import { useGetQuotationsByFileIdQuery } from '@savgroup-front-common/core/components/Quotation/hooks/useGetQuotationsByFileIdQuery';
import { QuotationLines } from '@savgroup-front-common/core/components/Quotation/QuotationLines';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import useGetSellerConfigurationById from '@savgroup-front-common/core/hooks/useGetSellerConfigurationById';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';
import { QuotationState } from '@savgroup-front-common/types/Quotation/QuotationState';

import { Description } from './Description';
import messages from './messages';
import QuotationTotal from './QuotationTotal/Quotationtotal';

function QuotationSummary({ fileId }: { fileId: string }) {
  const { quotations, isLoading } = useGetQuotationsByFileIdQuery({
    fileId,
    refetchOnMount: false,
  });

  const currentQuotation = (quotations || []).find(
    (quotation) => quotation.state === QuotationState.APPROVED,
  );

  const { data: sellerConfiguration } = useGetSellerConfigurationById({
    sellerId: currentQuotation?.sellerId || '',
  });

  if (!currentQuotation && isLoading) {
    return <BaseLoader />;
  }

  if (!currentQuotation) {
    return null;
  }

  return (
    <div>
      <Description data-testid="QuotationPaid_description">
        <strong>
          <SafeFormattedMessageWithoutSpread
            message={messages.descriptionLabel}
          />{' '}
          :{' '}
        </strong>
        {currentQuotation.description}
      </Description>

      <QuotationLines isActive quotation={currentQuotation} />

      <QuotationTotal quotation={currentQuotation} fileId={fileId} />

      {currentQuotation.bonus && !currentQuotation.isBonusRemoved && (
        <$BonusLine data-testid="bonus">
          <QualireparLogo />
          <div>
            <Bold>
              <SafeFormattedMessageWithoutSpread
                message={messages.congratulation}
              />
            </Bold>
            <p>
              <SafeFormattedMessageWithoutSpread
                message={messages.bonusDidactic}
              />
              {sellerConfiguration?.qualiReparUrl && (
                <Link
                  isExternal
                  href={sellerConfiguration?.qualiReparUrl}
                  target={TARGET_LINK.TARGET_BLANK}
                >
                  <SafeFormattedMessageWithoutSpread
                    message={messages.learnMore}
                  />
                </Link>
              )}
            </p>
          </div>
        </$BonusLine>
      )}
    </div>
  );
}

export default QuotationSummary;
